import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';

const triggerAfterDelay = (
    callback: () => void,
    delay = 500,
) => {
    setTimeout(callback, delay);
};

export const useOnboardingModalChain = (isSubscribeAvailable: boolean) => {
    const modalStore = useModalStore();

    const closeRegisterBonusAndOpenIntroduction = () => {
        triggerAfterDelay(() => {
            modalStore.toggleModal(ModalEnum.INTRODUCTION, true);
        });

        modalStore.toggleModal(ModalEnum.REGISTER_BONUS, false);
    };

    const closeIntroductionAndOpenGuildsSuggestions = () => {
        triggerAfterDelay(() => {
            modalStore.toggleModal(ModalEnum.GUILDS_SUGGESTIONS, true);
        });

        modalStore.toggleModal(ModalEnum.INTRODUCTION, false);
    };

    const closeGuildsSuggestionsAndOpenDownloadApp = () => {
        triggerAfterDelay(() => {
            modalStore.setDownloadAppModal(true, true);
        });

        modalStore.toggleModal(ModalEnum.GUILDS_SUGGESTIONS, false);
    };

    const closeDownloadAppAndOpenBrowserNotifications = () => {
        if (isSubscribeAvailable) {
            triggerAfterDelay(() => {
                modalStore.toggleModal(ModalEnum.BROWSER_NOTIFICATIONS, true);
            });
        }

        modalStore.setDownloadAppModal(false);
    };

    return {
        closeRegisterBonusAndOpenIntroduction,
        closeIntroductionAndOpenGuildsSuggestions,
        closeGuildsSuggestionsAndOpenDownloadApp,
        closeDownloadAppAndOpenBrowserNotifications,
    };
};
